<template>
  <div class="Orders">
    <div class="select">
      <el-select v-model.number="serviceFlag" placeholder="请选择" @change="handleServiceIdSelect">
        <el-option v-for="(item, index) in serviceIdList" :key="index" :label="item.serviceName" :value="item.serviceFlag"></el-option>
      </el-select>
    </div>
    <div class="ajie_table">
      <el-table :data="tableData3" border>
        <el-table-column label="订单编号" width="166px">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="details(scope.row.orderType, scope.row.orderId)">{{scope.row.orderId}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="ordertime" label="下单时间" width="125px">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="details(scope.row.orderType, scope.row.orderId)">{{scope.row.createTime | DateFilter('yyyy-MM-dd hh:mm')}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="服务名称" >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="details(scope.row.orderType, scope.row.orderId)" class="textOver title">{{scope.row.title }}</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="processingTime" label="处理时间" width="119px">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="details(scope.row.orderType)">{{scope.row.processingTime}}</el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="状态" width="90px">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="details(scope.row.orderType, scope.row.orderId)">{{scope.row.orderStatus | orderStatus(scope.row.orderType)}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="订单金额(元)" width="100px">
          <template slot-scope="scope">
            <el-button v-if="scope.row.orderType ===18" type="text" size="small" @click="details(scope.row.orderType, scope.row.orderId)">{{scope.row.orderFee / 100 | PriceFilter}}</el-button>
            <el-button v-else type="text" size="small" @click="details(scope.row.orderType, scope.row.orderId)">{{scope.row.approvalFee / 100 | PriceFilter}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy main-pagination" v-if="msgtotal > 9">
      <el-pagination background layout="prev, pager, next" :total="msgtotal"  @current-change="handleCurrentChange" :page-size="9"></el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data(){
    return{
      serviceFlag: '', // 8大服务的serviceFlag
      msgtotal: 0,
      pageIndex: 1,
      oderId: '', // 订单编号（转成字符串，处理失真问题）
      orderType: -1,
      serviceIdList: [],
      tableData3:[],
    }
  },
  methods:{
    details(Ty, id) {
      this.$router.push({ path: `/navigator/personal/orderDetail`, query: { orderType: Ty, orderId: id } });
    },
    getlist() {
      if (this.serviceFlag === 9) {
        this.tableData3 = [];
        this.$http.post(`${this.URL_PREFIX}/app/get/user/shop/order/list`, {
          currPage: this.pageIndex,
          pageRows: 9,
        },{
          headers: { token: this.token },
        }).then((respon) => {
          const res = respon.data;
          if(res.resCode === '10000') {
            this.tableData3 = res.resData.pageList ? res.resData.pageList : [];
            this.msgtotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
            this.orderType = res.resData.orderType;
          }
        });
      }else {
        const askBoby = {
          currPage: this.pageIndex,
          pageRows: 9,
        };
        if (this.serviceFlag !== '') {
          askBoby.serviceFlag = this.serviceFlag;
        }
        this.$http.post(`${this.URL_PREFIX}/app/get/user/order/info/list`, askBoby,{
          headers: { token: this.token },
        }).then((respon) =>{
          const res = respon.data;
          if(res.resCode === '10000') {
            this.tableData3 = res.resData.pageList ? res.resData.pageList : [];
            this.msgtotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
            this.orderType = res.resData.orderType;
          }
        });
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getlist();
    },
    handleServiceIdSelect(val) {
      this.pageIndex = 1;
      this.getlist();
    },
  },
  mounted() {
    this.getlist();
  },
  filters: {
    orderType(num) {
      switch (num) {
        case 3:
          return '自定义服务';
        case 4:
          return '找工作';
        case 5:
          return '服务外包';
        case 6:
          return '培训';
        case 7:
          return '产品路演';
        case 8:
          return '求购';
        case 9:
          return '美食街';
        case 10:
          return '入驻';
        case 11:
          return '优选服务';
        case 12:
          return '会议室';
        case 13:
          return '活动';
        case 14:
          return '福利';
        case 15:
          return '微社区';
        case 16:
          return '设施出租';
        case 17:
          return '商城';
        case 18:
          return '物业报修';
        default:
          break;
      }
    },
    orderStatus(num, orderType) {
      switch (num) {
        case 0:
          return '删除';
        case 1:
          return orderType==9 ? '待接单' : '待审批';
        case 2:
          return '审批中';
        case 3:
          return '审批不通过';
        case 4:
          return '用户取消';
        case 5:
          return '待支付';
        case 6:
          return '完成';
        case 7:
          return '订单关闭';
        case 8:
          return '已退款';
        case 9:
          return '退款中';
        default:
          break;
      }
    },
  },
  computed: {
    ...mapGetters(['token', 'parkServiceList']),
  },
  created(){
    this.serviceIdList = [];
    this.parkServiceList.forEach((v)=>{
      this.serviceIdList.push({
        serviceFlag: v.serviceFlag,
        serviceId: v.serviceId,
        serviceName: v.serviceName,
      });
    });
    this.serviceIdList.push({
      serviceFlag: 9,
      serviceId: 0,
      serviceName: '天安商城',
    });
  },
}
</script>
<style lang="scss" scoped>
.Orders{
  .select{
    width: 940px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px;
  }
  .ajie_table{
    padding: 20px;
    font-size: 12px;
    background-color: #fff;
    .el-table{
      font-size: 12px;
      .el-button{
        color: #333;
        font-weight: normal;
        &.title {
          width: 400px;
        }
        &:hover{
          text-decoration: underline;
        }
      }
    }
  }
}
.fy{
  text-align: center;
  margin-top: 76px;
}
</style>



// WEBPACK FOOTER //
// src/pages/navigator/personal/components/info/Orders.vue